/**
 * 素材类
 */
export default class Material {
  constructor(material = {}) {
    this.index = material.index || 0; //index 唯一标识位
    this.windowId = material.windowId || 0;
    this.materialId = material.materialId || ""; //素材id
    this.materialName = material.materialName || ""; //素材名称
    this.src = material.src || ""; //素材原图url
    this.materialThumbnailUrl = material.materialThumbnailUrl || ""; //素材缩略图url
    this.materialDeleteFlag = material.materialDeleteFlag || false; //素材删除标识 true 已删除
    this.fileType = material.fileType || "";
    this.switchEffect = material.switchEffect || "none"; //切换效果
    this.playTimeType = material.playTimeType || "selfDefine"; //播放时间类型
    this.materialTime = material.materialTime || 10; //素材时间
    this.materialType = material.materialType || ""; //素材类型
    this.validityTime = material.validityTime || ""; //素材有效期时间
    //document
    this.fontSize = material.fontSize || 30; //字体大小(需要等比例显示转换)
    this.fontColor = material.fontColor || "#FF0000"; //字体颜色
    this.backgroundColor = material.backgroundColor || "#000000"; //背景颜色
    this.backTransparent = material.backTransparent || 0; //透明度，终端是0是全透明（web0是不透明）
    this.scrollDirection = material.scrollDirection || "up"; //滚动方向
    this.scrollSpeed = material.scrollSpeed || 5; //滚动速度
    this.pageTime = material.pageTime || 10; //页面时间(pdf)
    //realStream
    this.inputChannel = material.inputChannel || 0;
    this.scaleType = material.scaleType || false; //是否等比例放大
    this.webType = material.webType || "mobile"; // 网页属性 desktop#PC端，mobile#移动端
  }
}
